import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';
import { toast } from 'sonner';

const SessionHistory = ({ sessions, onDeleteSession }) => {
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const handleDelete = (sessionId) => {
    if (window.confirm('Are you sure you want to delete this session?')) {
      onDeleteSession(sessionId);
    }
  };

  return (
    <Card className="backdrop-blur-sm bg-white/90 border-emerald-200 shadow-xl" data-testid="session-history">
      <CardHeader>
        <CardTitle className="text-2xl text-emerald-900">Session History</CardTitle>
        <CardDescription className="text-emerald-700">
          Your outdoor adventures ({sessions.length} sessions)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[500px] pr-4">
          {sessions.length === 0 ? (
            <div className="text-center py-12 text-emerald-600">
              <div className="text-4xl mb-4">🏕️</div>
              <p>No sessions yet. Start tracking your outdoor time!</p>
            </div>
          ) : (
            <div className="space-y-3">
              {sessions.map((session, index) => (
                <div
                  key={session.id}
                  data-testid={`session-${index}`}
                  className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl p-4 border border-emerald-200 hover:shadow-md transition-shadow"
                >
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-emerald-900 font-semibold">
                          {formatDate(session.start_time)}
                        </span>
                        <Badge
                          variant="secondary"
                          className={`text-xs ${
                            session.session_type === 'timer'
                              ? 'bg-emerald-100 text-emerald-700'
                              : 'bg-teal-100 text-teal-700'
                          }`}
                        >
                          {session.session_type}
                        </Badge>
                      </div>
                      <div className="text-sm text-emerald-700">
                        {formatTime(session.start_time)} - {formatTime(session.end_time)}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-2xl font-bold text-emerald-900">
                        {session.duration_minutes}
                      </div>
                      <div className="text-xs text-emerald-600">minutes</div>
                    </div>
                  </div>
                  {session.notes && (
                    <div className="text-sm text-emerald-700 bg-white/50 rounded-lg p-2 mb-2">
                      {session.notes}
                    </div>
                  )}
                  <div className="flex justify-end">
                    <Button
                      onClick={() => handleDelete(session.id)}
                      data-testid={`delete-session-${index}`}
                      variant="ghost"
                      size="sm"
                      className="text-red-600 hover:text-red-700 hover:bg-red-50 text-xs"
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </ScrollArea>
      </CardContent>
    </Card>
  );
};

export default SessionHistory;